export enum PublisherMetadataKeys {
  UPLOAD_DESIGN_LIMIT_METADATA_KEY = 'uploadDesignLimit',
  USED_LOCALE_FOR_VARIANTS_OPTIONS = 'usedLocaleForVariantsOptions',
}
